import gql from 'graphql-tag'
import { type Partner } from 'legacy/common/types'
import { useDeepMemo } from '@retailer-platform/shared-common'
import { useRetailersQuery } from 'legacy/apollo/clientHooks'
import { toInteger } from 'utils/parsing/numbers'

export const FETCH_PARTNERS_QUERY = gql`
  query {
    currentPartnerUser {
      partners {
        id
        name
      }
    }
  }
`

export interface PartnersData {
  currentPartnerUser: {
    partners: (Omit<Partner, 'id'> & { id: string })[]
  }
}

export const useFetchPartners = () => {
  const { data, error, loading } = useRetailersQuery<PartnersData, {}>(FETCH_PARTNERS_QUERY)

  // Convert the id strings into integers
  const partners: Partner[] = useDeepMemo(
    () =>
      data &&
      data.currentPartnerUser.partners.map(({ id, ...rest }) => ({
        id: toInteger(id),
        ...rest,
      })),
    [data]
  )

  return {
    partners,
    error,
    loading,
  }
}
